// import React, { useEffect, useState } from 'react';
// import SweetAlertModal from '../../../components/SweetAlertModal/SweetAlertModal';
// import Cancel from './../../../../assets/icons/close.png';
// import itemImg from './../../../../assets/icons/menu.png';
// import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';
// import { ToastContainer, toast } from 'react-toastify'
// import Typography from '@mui/material/Typography'
// import AutoCompleteMultiSelect from '../../../../pages/components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx'
// import { styled } from "@mui/material/styles";
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
// //import "./ArchiveDialog.css";

// import axios from 'axios';

// import {
//   Button,
//   Grid,
//   Switch,
//   Dialog,
//   DialogActions,
//   DialogContent, 
//   DialogContentText,
//   DialogTitle,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   tooltipClasses,
//   Tooltip,
//   Tabs, 
//   Tab,
//   Autocomplete,
//   TextField
// } from '@mui/material';

// function SectionSchedulerSelectDialog(props) {
//   console.log(props);

//   const [openDialog, setOpenDialog] = useState(false);
//   const [selectedRowId, setSelectedRowId] = useState(null);
//   const [openMenuCloseConfirmaitonModal, setopenMenuCloseConfirmaitonModal] =useState(false);
//   const [openArchiveConfirmaitonModal, setopenArchiveConfirmaitonModal] =useState(false);
//   const [selectedValue, setSelectedValue] = useState<any>(null);
//   const [dataRows, setDataRows] = useState([]);
//   const [menuSelected, setmenuSelected] = useState([]);
//   const apiAddress = process.env.REACT_APP_SECRET;

//   const handleClose = () => {
//     // props.onHandleAddItem(restaurantId);
//     // // setKeyword(null)
//     // setSelectedValue(null);
//     // setopenMenuCloseConfirmaitonModal(false);
//     // setopenArchiveConfirmaitonModal(false);
//     // setOpenDialog(false);
//     //setRestaurantId([]);  
//     props.onClose()
//   };
//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//     setSelectedRowId(null);
//   };

//   const { open, onClose, dialogType,restaurantSelected } = props;

//   console.log(restaurantSelected)

//   const [selectedTab, setSelectedTab] = useState(0);

//   const handleTabChange = (event, newValue) => {
//     setSelectedTab(newValue); // Update selected tab
//   };
//   const [selectedSchedule, setselectedSchedule] = React.useState([]);
//   const [schedulerDatas, setschedulerDatas] = React.useState([]);
//   const addScheduleValueData = (dt) => {
//     // if (dt.length > 1 && Item.length > 0) {
//     //     setTempSelectedSchedule(dt);
//     //     handleTempSchedulerAdd();
//     //     setOpenSchedulerSelectionModal(true);
//     //   } else {
//     //     setselectedSchedule(dt);
//     //     setselectedSchedularObj(dt);
//     //   }
//       setselectedSchedule(dt);
//   };
//   useEffect(() => {
//     loadData();
//   }, []);

//   const loadData = async () => {
//     axios({
//       method: "get",
//       url: apiAddress + "/api/Schedule",
//     })
//       .then(function (response) {
//         var temp = [];
//         response.data.map((dt, index) => {
//           var obj = {
//             id: dt.scheduleId,
//             title: dt.scheduleName,
//             contentId: null,
//           };
//           temp.push(obj);
//         });
//         setschedulerDatas([...temp]);
//         // setschedulerDataFactory(JSON.parse(JSON.stringify(temp)));
//       })
//       .catch(function (error) {
//         console.log(error);
//         toast.error(error.response.data, {
//           position: "top-right",
//           autoClose: 5000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//           theme: "colored",
//         });
//       });
//   };

//   const [scheduleSelections, setScheduleSelections] = useState({});

//   const handleScheduleChange = (restaurantId, selectedSchedule) => {
//     setScheduleSelections((prevState) => ({
//       ...prevState,
//       [restaurantId]: selectedSchedule,
//     }));
//   };

//   useEffect(() => {
//     console.log(scheduleSelections)
//   }, [scheduleSelections]);

//   console.log(restaurantSelected)

//   const [selections, setSelections] = useState({});

//   return (
//     <div>
//       <React.Fragment>
//         <Dialog
//           maxWidth={'md'}
//           fullWidth={true}
//           open={props.open}
//           onClose={handleClose}
//         >
//           <SweetAlertModal
//             headerText={'Do you want to leave without saving?'}
//             bodyText={'All changes made will be lost'}
//             open={openMenuCloseConfirmaitonModal}
//             onyes={handleClose}
//             close={() => {
//               setopenMenuCloseConfirmaitonModal(false);
//             }}
//             id={2}
//           />
//           <Grid container>
//             <Grid item xs={6}>
//               <DialogTitle>
//                 <div className='d-flex' style={{ gap: '8px' }}>
//                   <div>
//                     <img src={itemImg} style={{ width: '1.8rem' }} alt='' />
//                   </div>

//                   <span style={{ color: '#2a7fd4' }}>
//                     GoTaste :- Menu Scheduler Select
//                   </span>
//                 </div>
//               </DialogTitle>
//             </Grid>
//             <Grid item xs={6}>
//               <DialogActions>
//                 <Button onClick={() => setopenMenuCloseConfirmaitonModal(true)}>
//                   <img src={Cancel} alt='Close' style={{ width: '1.2rem' }} />
//                 </Button>
//               </DialogActions>
//             </Grid>
//           </Grid>
//           <DialogContent style={{ backgroundColor: '#f3f0f3' }}>
//           <Tabs
//               value={selectedTab}
//               onChange={handleTabChange}
//               indicatorColor="primary"
//               textColor="primary"
//               variant="scrollable"
//               scrollButtons="auto"
//             >
//               {restaurantSelected.map((restaurant, index) => (
//                 <Tab
//                   key={restaurant.id}
//                   label={restaurant.title +" || "+ restaurant.restaurantName}
//                   //disabled={!restaurant.isDelivery}
//                 />
//               ))}
//             </Tabs>
//             <div style={{ marginTop: '16px' }}>
//               {restaurantSelected[selectedTab] && (
//             <Grid container>
//                   <Grid item xs={2}>
//                     <Typography style={{ paddingTop: "1rem" }}>
//                       Select Schedule
//                     </Typography>
//                   </Grid>
//                   <Grid item xs={7} style={{ paddingTop: "0.5rem" }}>
//                     {/* <AutoCompleteMultiSelect
//                       label={`Select Schedule for ${restaurantSelected[selectedTab].title}`}
//                       placeholder={"Schedule"}
//                       value={scheduleSelections[restaurantSelected[selectedTab].id] || []}
//                       datas={schedulerDatas}
//                       val={selectedSchedule}
//                       onChange={(selectedValue) =>
//                         handleScheduleChange(restaurantSelected[selectedTab].id, selectedValue)
//                       }
//                       id={44}
//                     /> */}

//                     {/* <AutoCompleteMultiSelect
//                       label={`Select Schedule for ${restaurantSelected[selectedTab].title}`}
//                       placeholder={"Schedule"}
//                       value={addScheduleValueData}
//                       datas={schedulerDatas}
//                       val={selectedSchedule}
//                       id={2}
//                     /> */}

//                     <Autocomplete
//                         id={`single-select-${restaurantSelected[selectedTab].id}`}
//                         options={schedulerDatas}
//                         getOptionLabel={(option) => option.title}
//                         value={scheduleSelections[restaurantSelected[selectedTab].id] || null}
//                         onChange={(event, newValue) => handleScheduleChange(restaurantSelected[selectedTab].id, newValue)}
//                         renderInput={(params) => <TextField {...params} label="Select Option" variant="outlined" />}
//                         sx={{ width: '100%', paddingY: '.5rem' }}
//                     />
//                   </Grid>

//                   <Grid item xs={2} style={{ paddingTop: "0rem" }}>
//                     <button
//                       className="btn "
//                       style={{ color: "blue", fontSize: "1rem" }}
//                       onClick={() => {
//                         //setOpen(true);
//                       }}
//                     >
//                       {" "}
//                       +Create New Schedule
//                     </button>
//                   </Grid>
//             </Grid>
            
//               )}
//               </div>
//             {/* <div style={{ marginTop: '16px' }}>
//               {restaurantSelected[selectedTab] && (
//                 <div>
//                   <h3>{restaurantSelected[selectedTab].title}</h3>
//                   <p>ID: {restaurantSelected[selectedTab].id}</p>
//                   <p>
//                     Delivery: {restaurantSelected[selectedTab].isDelivery ? 'Available' : 'Not Available'}
//                   </p>
//                 </div>
//               )}
//             </div> */}
//           </DialogContent>
//           <DialogActions>
//             <Button
//                 onClick={() => setopenMenuCloseConfirmaitonModal(true)}
//                 color='primary'
//             >
//                 Close
//             </Button>
//             </DialogActions>
//         </Dialog>
//       </React.Fragment>
//     </div>
//   );
// }

// export default SectionSchedulerSelectDialog;

import React, { useEffect, useState } from 'react';
import SweetAlertModal from '../../../components/SweetAlertModal/SweetAlertModal';
import Cancel from './../../../../assets/icons/close.png';
import itemImg from './../../../../assets/icons/menu.png';
import SchedulerDetailsTable from "../SchedulerView/SchedulerDetailsViewWithTable/SchedulerDetailsTable.tsx";
import CreateNewSchedule from "../SchedulerView/ScheduleItemDialog/CreateNewSchedule/CreateNewSchedule.tsx";
import { ToastContainer, toast } from 'react-toastify';
import Typography from '@mui/material/Typography';
import axios from 'axios';
import {
  Button,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tabs,
  Tab,
  Autocomplete,
  TextField,
} from '@mui/material';

function SectionSchedulerSelectDialog(props) {
  const [schedulerDatas, setSchedulerDatas] = useState([]);
  const [scheduleSelections, setScheduleSelections] = useState(props.prevScheduleSelecection  || {});
  const [selectedTab, setSelectedTab] = useState(0);
  const [scheduleDetails, setScheduleDetails] = useState({}); 
  const [open, setOpen] = useState(false);
  const apiAddress = process.env.REACT_APP_SECRET;
  console.log(props);
  useEffect(() => {
    loadData();
    console.log(props.restaurantSelected)
  }, []);


  const handleSave = () => {
    if (props.onSave) {     

      toast.success("Scheduler saved", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
      props.onSave(scheduleSelections); 
    }
    props.onClose();
  };

  useEffect(() => {
    const fetchInitialSchedules = async () => {
      const restaurantId = props.restaurantSelected[selectedTab]?.id;
      const initialSelection = scheduleSelections[restaurantId];
  
      if (restaurantId && initialSelection) {
        await fetchScheduleDetails(restaurantId, [initialSelection]);
      }
    };
  
    fetchInitialSchedules();
  }, [props.restaurantSelected, selectedTab, scheduleSelections]);

  const loadData = async () => {
    try {
      const response = await axios.get(`${apiAddress}/api/Schedule`);
      const temp = response.data.map((dt) => ({
        id: dt.scheduleId,
        title: dt.scheduleName,
        contentId: null,
      }));
      setSchedulerDatas(temp);
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data || "Failed to load schedules", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
    }
  };

  const handleScheduleChange = async (restaurantId, newValue) => {
    setScheduleSelections((prev) => ({
      ...prev,
      [restaurantId]: newValue,
    }));

    if (newValue) {
      await fetchScheduleDetails(restaurantId, [newValue]);
    } else {
      setScheduleDetails((prev) => ({
        ...prev,
        [restaurantId]: { addedSchedulers: [], conflictedSchedulers: [] },
      }));
    }
  };

  const fetchScheduleDetails = async (restaurantId, selectedSchedules) => {
    const ids = selectedSchedules.map((item) => item.id);

    try {
      const response = await axios.post(`${apiAddress}/api/Schedule/getschedulebyidlist`, ids);
      setScheduleDetails((prev) => ({
        ...prev,
        [restaurantId]: {
          addedSchedulers: response.data.schedulerDatas,
          conflictedSchedulers: response.data.conflictedData,
        },
      }));
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data || "Failed to fetch schedule details", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
    }
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleClose = () => {
    props.onClose();
  };

  const handleAddItem = (AddItemData) => {
    setOpen(AddItemData);
    loadData();
  };

  return (
    <Dialog maxWidth="md" fullWidth={true} open={props.open} onClose={handleClose}>
      <Grid container>
        <Grid item xs={6}>
          <DialogTitle>
            <div className="d-flex" style={{ gap: "8px" }}>
              <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
              <span style={{ color: "#2a7fd4" }}>GoTaste :- Menu Scheduler Select</span>
            </div>
          </DialogTitle>
        </Grid>
        <Grid item xs={6}>
          <DialogActions>
            <Button onClick={handleClose}>
              <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
            </Button>
          </DialogActions>
        </Grid>
      </Grid>
      <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          {props.restaurantSelected.map((restaurant) => (
            <Tab key={restaurant.id} label={restaurant.title +" || "+ restaurant.restaurantName} />
          ))}
        </Tabs>
        <div style={{ marginTop: "16px" }}>
          {props.restaurantSelected[selectedTab] && (
            <Grid container>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>Select Schedule</Typography>
              </Grid>
              <Grid item xs={7} style={{ paddingTop: "0.5rem" }}>
                <Autocomplete
                  id={`single-select-${props.restaurantSelected[selectedTab].id}`}
                  options={schedulerDatas}
                  getOptionLabel={(option) => option.title}
                  value={scheduleSelections[props.restaurantSelected[selectedTab].id] || null}
                  onChange={(event, newValue) =>
                    handleScheduleChange(props.restaurantSelected[selectedTab].id, newValue)
                  }
                  renderInput={(params) => <TextField {...params} label="Select Schedule" variant="outlined" />}
                  sx={{ width: "100%", paddingY: ".5rem" }}
                />
              </Grid>
              <Grid item xs={2} style={{ paddingTop: "1rem" }}>
              <button
                      className="btn "
                      style={{ color: "blue", fontSize: "1rem" }}
                      onClick={() => {
                        setOpen(true);
                      }}
                    >
                      {" "}
                      +Create New Schedule
                    </button>
          </Grid>
            </Grid>
          )}
        </div>
        {props.restaurantSelected[selectedTab] &&
          scheduleDetails[props.restaurantSelected[selectedTab].id]?.addedSchedulers?.length > 0 && (
            <SchedulerDetailsTable
              addedtempSchedulers={
                scheduleDetails[props.restaurantSelected[selectedTab].id]?.addedSchedulers || []
              }
            />
          )}
      </DialogContent>
      <CreateNewSchedule
        open={open}
        onHandleAddItem={handleAddItem}
        title={props.title}
      />
      <DialogActions>
      <Button onClick={handleSave} color="primary">
          Save
        </Button>
        <Button onClick={handleClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SectionSchedulerSelectDialog;

